import { GridConfig } from "../modules/GridConfig";
import { getInstanceIDFromCanvasInstance } from "../../../diagram/diagram-assets/diagram-positioning-state";

/**
 * @descrription Utility class for cell retrieval
 */
export class CellRetrievalUtils {
    /**
     *
     * @param {Object} cell - {row, col} cell position indexes inside the grid matrix
     * @param {GridCell[]} grid
     * @returns { GridCell | null }
     */
    getCell(cell, grid) {
        return cell && grid && grid[cell.row] && grid[cell.row][cell.col] ? grid[cell.row][cell.col] : null;
    }

    /**
     * @description Returns the position of the cell inside the grid.
     * @param {Object} pos - {x,y} current mouse position
     * @param {Object} temp - Temporary grid options
     * @param {GridCell[][]} grid - generated grid matrix
     */
    getCellPosition(pos, temp, grid) {
        const instanceId = getInstanceIDFromCanvasInstance(grid[0][0].ctx);
        const gridConfig = new GridConfig(instanceId);
        const { cellHeight } = gridConfig;
        const { cellWidth } = gridConfig;
        const objToReturn = {};
        const padding = this.getPadding(grid);
        objToReturn.row = Math.floor((pos.y - padding.y) / cellHeight);
        objToReturn.col = Math.floor((pos.x - padding.x) / cellWidth);
        return objToReturn;
    }

    /**
     * @description Returns grid padding
     * @param { GridCell[][] } grid - generated grid matrix
     * @param { String } side - the side the grid is being generated on
     * @returns { Object } - {x,y} object indicating grid starting point
     */
    getPadding(grid) {
        if (!grid[0][0]) {
            grid = grid.filter(x => x.length > 0);
        }
        const instanceId = getInstanceIDFromCanvasInstance(grid[0][0].ctx);
        const gridConfig = new GridConfig(instanceId);
        const cell = grid[0][0];
        if (cell) {
            return { x: cell.layout.x, y: cell.layout.y };
        }
        return { x: gridConfig.viewPadding, y: gridConfig.viewPadding };
    }
}
